import Card from "./Card";
import styles from "./styles.css";

export { Card, styles };
